import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';

import Loading from 'Components/Loading';
import { ROUTES } from 'Settings/route-strings';

// This is used as the base for authenticated users,
// but also for the logging-out routes
const options = {
  redirectPath: ROUTES.SIGN_IN,
  allowRedirectBack: true,
  authenticatedSelector: state => {
    return (
      state.users.auth.token !== null &&
      state.users.auth.tokenExpiration > Date.now()
    );
  },
  wrapperDisplayName: 'UserIsAuthenticated',
};

const authenticatedOptions = {
  ...options,
  authenticatingSelector: state =>
    state.users.auth.checkingToken || state.users.activeUser.isFetching,
  AuthenticatingComponent: Loading,
};

export const userIsAuthenticated = connectedRouterRedirect(
  authenticatedOptions
);

const userHasRole = roleBoolean => {
  return connectedRouterRedirect({
    ...authenticatedOptions,
    authenticatedSelector: state => {
      const authState = state.users.auth;
      return (
        authState.token !== null &&
        authState.tokenExpiration > Date.now() &&
        state.users.activeUser.user &&
        state.users.activeUser.user[roleBoolean]
      );
    },
  });
};

export const userIsAdmin = userHasRole('isAdmin');
export const userIsEducator = userHasRole('isEducator');
export const userIsSuperAdmin = userHasRole('isSuperAdmin');

export const userIsLoggingOut = connectedRouterRedirect({
  ...options,
  redirectPath: ROUTES.INDEX,
  allowRedirectBack: false,
});
